import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FixDomainPipe } from './fix-domain.pipe';

@NgModule({
  declarations: [FixDomainPipe],
  imports: [CommonModule],
  exports: [FixDomainPipe],
})
export class FixDomainPipeModule {}
